import { render, staticRenderFns } from "./stdsts.vue?vue&type=template&id=44b01cec&"
import script from "./stdsts.vue?vue&type=script&lang=js&"
export * from "./stdsts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports